import { Table, type StackProps } from '@chakra-ui/react';

export type UiTableProps = StackProps;

export const UiTable = Table;
